import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Tim Robinson",
        title: "CEO & Founder",
        biography: "Tim Robinson is the visionary CEO and founder of our company. With a passion for innovation and leadership, he has built a brand that prioritizes quality, creativity, and customer satisfaction. His entrepreneurial spirit drives the team forward. Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam repellat dolore vero possimus consequatur pariatur suscipit distinctio accusantium! Consequuntur, cum!",
        contacts: {
            phone: "555-789-1234",
            email: "tim.robinson@example.com",
            address: "456 Innovation Drive, Level 5, Metrocity, ST 67890",
            website: "www.timrobinson.co"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Founder & Strategist",
            "Executive Leadership",
            "Brand Architect",
            "Business Developer",
            "Team Mentor"
        ],
        skills: [
            { id: 1, title: "Leadership", progress: 98 },
            { id: 2, title: "Strategic Planning", progress: 95 },
            { id: 3, title: "Business Development", progress: 92 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Wendy Watson",
        title: "Project Manager",
        biography: "Wendy Watson is a dynamic Project Manager known for her precision and dedication. She excels at coordinating projects from concept to completion while maintaining high standards of quality and communication. With a keen eye for detail and a proactive mindset, she ensures timely and successful project execution.",
        contacts: {
            phone: "555-321-4567",
            email: "wendy.watson@example.com",
            address: "789 Creative Lane, Suite 210, Metrocity, ST 67890",
            website: "www.wendywatson.co"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Workflow Optimization",
            "Client Communication",
            "Timeline Management",
            "Team Coordination",
            "Risk Assessment"
        ],
        skills: [
            { id: 1, title: "Project Coordination", progress: 94 },
            { id: 2, title: "Communication", progress: 91 },
            { id: 3, title: "Time Management", progress: 89 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Chris Smith",
        title: "Senior Designer",
        biography: "Chris Smith is a highly skilled Senior Designer with a passion for visual storytelling and brand aesthetics. With years of experience in graphic and product design, he brings creativity, technical expertise, and a keen sense for current trends to every project. His designs consistently blend function with flair, making a lasting impact.",
        contacts: {
            phone: "555-654-9870",
            email: "chris.smith@example.com",
            address: "321 Design Avenue, 3rd Floor, Metrocity, ST 67890",
            website: "www.chrissmith.design"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Brand Identity Design",
            "Product Design",
            "UI/UX Design",
            "Print & Digital Graphics",
            "Creative Direction"
        ],
        skills: [
            { id: 1, title: "Graphic Design", progress: 96 },
            { id: 2, title: "Creative Thinking", progress: 93 },
            { id: 3, title: "UI/UX Design", progress: 90 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Suzie Kitson",
        title: "Designer",
        biography: "Suzie Kitson is a creative and detail-oriented Designer who brings fresh ideas and vibrant energy to every project. Her strength lies in combining aesthetics with functionality across print and digital platforms. Suzie’s collaborative approach and eye for modern design trends make her an essential part of the creative team.",
        contacts: {
            phone: "555-213-8745",
            email: "suzie.kitson@example.com",
            address: "112 Studio Street, 2nd Floor, Metrocity, ST 67890",
            website: "www.suziekitson.art"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Print Design",
            "Social Media Graphics",
            "Layout & Composition",
            "Brand Support",
            "Collaborative Projects"
        ],
        skills: [
            { id: 1, title: "Visual Design", progress: 88 },
            { id: 2, title: "Adobe Creative Suite", progress: 90 },
            { id: 3, title: "Branding Support", progress: 85 },
        ]
    }
];

export default team;